import { useSelector } from "react-redux";

import { CloseFullScreenIcon } from "../../icons/CloseFullScreenIcon/CloseFullScreenIcon";
import { PlusIcon } from "../../icons/PlusIcon/PlusIcon";
import { RootState } from "../../store";
import { formatPropertyLabel } from "../../utils/parseAddress";
import { truncateFileName } from "../../utils/truncateFileName";

import styles from "./multipleobjectselect.module.css";

const MultipleObjectSelect = ({
  selectedObjects,
  setSelectedObjects,
  onPlusIconClick,
  editMode,
  addUser
}: {
  selectedObjects: any[];
  setSelectedObjects: (objects: any[]) => void;
  onPlusIconClick?: () => void;
  editMode?: boolean;
  addUser?: boolean;
}) => {
  const userProperties = useSelector(
    (state: RootState) => state.user.properties
  );

  const customerProperties = useSelector(
    (state: RootState) => state.userManagement.customerProperties
  );

  const properties =
    userProperties && userProperties.length > 0
      ? userProperties
      : customerProperties || [];

  const mappedInitialObjects = selectedObjects
    .map((propertyId) => properties.find((item) => item.id === propertyId))
    .filter(Boolean);

  const displayedObjects =
    mappedInitialObjects.length > 0 ? mappedInitialObjects : selectedObjects;

  const handleRemove = (value: string) => {
    const updatedObjects = selectedObjects.filter((obj) =>
      obj.value ? obj.value !== value : obj !== value
    );

    setSelectedObjects(updatedObjects);
  };

  return (
    <div
      role="button"
      className={`${styles["multi-object-uploader"]} ${editMode ? styles["edit-mode"] : ""
        }`}
    >
      <label
        className={`${styles["object-uploader-button"]} ${editMode ? styles["edit-mode"] : ""
          }`}
      >
        <span>{"Objekt"}</span>
        {(editMode || addUser) && (
          <PlusIcon
            color="green"
            handlePlusClicked={() => {
              if (onPlusIconClick) onPlusIconClick();
            }}
          />
        )}
      </label>

      <div
        className={`${styles["object-list"]} ${editMode ? styles["edit-mode"] : ""
          }`}
      >
        {displayedObjects.length > 0 ? (
          displayedObjects.map((property, index) => (
            <div
              className={`${styles["object-item"]} ${editMode ? styles["edit-mode"] : ""
                }`}
              key={`object-${index}`}
            >
              <span>
                {truncateFileName(
                  property?.street
                    ? formatPropertyLabel(property)
                    : `${property?.label}`,
                  30
                )}
              </span>
              {(addUser || editMode) && (
                <CloseFullScreenIcon
                  onClick={() => handleRemove(property?.value ?? property?.id)}
                />
              )}
            </div>
          ))
        ) : (
          <span className={styles["placeholder-text"]}>
            {"Objekte auswählen"}
          </span>
        )}
      </div>
    </div>
  );
};

export default MultipleObjectSelect;
